export enum EditUserTab {
  PROFILE = 'profile',
  VEHICULE_CHECKS = 'vehiculeChecks',
  SECURITY = 'security',
}
